module.exports = __webpack_public_path__ + "img/soda.be5030ca.webp";